import getFileProviderItems from '../../actions/getFileProviderItems';
import searchFileProviderItems from '../../actions/search/searchFileProviderItems';
import FilePickerPanelViewState from '../../store/schema/FilePickerPanelViewState';
import GetFileProviderItemsResponse from '../../types/GetFileProviderItemsResponse';

export default async function getOrSearchFileProviderItems(
    viewState: FilePickerPanelViewState,
    isRefreshing: boolean = false
): Promise<GetFileProviderItemsResponse> {
    const {
        selectedFileProvider,
        selectedProviderScope,
        filePickerViewState: {
            selectedFolder: folder,
            fileProviderItems,
            pagingMetadata,
            columnSorting,
            searchViewState: { searchQuery, isInSearchMode },
            filterOptionsState,
        },
    } = viewState;

    const fileProviderId = selectedFileProvider.model.Id;
    const fileProviderEndpointUrl = selectedFileProvider.model.EndPointUrl;
    const fileProviderType = selectedFileProvider.type;
    var itemsEndpointUrl: string = null;
    let { key = null, location = null } = folder || {};

    // for shared a folder, the location is specified as a relative path.
    // the folder endpointUrl has to be used as itemsEndpointUrl to make request to SPO.
    if (folder?.model?.ProviderEndpointUrl) {
        itemsEndpointUrl = folder.model.ProviderEndpointUrl;
    }

    if (!isInSearchMode) {
        return await getFileProviderItems(
            fileProviderType,
            fileProviderId,
            isRefreshing ? 0 : fileProviderItems.length,
            filterOptionsState.selectedFilterOption,
            selectedProviderScope,
            fileProviderEndpointUrl,
            key /* folderId */,
            location,
            pagingMetadata,
            columnSorting,
            itemsEndpointUrl
        );
    } else {
        return await searchFileProviderItems(
            fileProviderType,
            fileProviderId,
            searchQuery,
            fileProviderItems.length,
            key /* folderId */,
            location,
            pagingMetadata,
            columnSorting
        );
    }
}
